// src/specs/v1/state.ts
var DEFAULT_STATE = {
  bio: "",
  lore: "",
  messageDirections: "",
  postDirections: "",
  actors: "",
  recentMessages: "",
  recentMessagesData: []
};
function fromV2State(stateV2) {
  const state = {
    ...DEFAULT_STATE,
    ...stateV2.values,
    ...stateV2.data,
    text: stateV2.text
  };
  for (const key in stateV2) {
    if (key !== "values" && key !== "data" && key !== "text") {
      state[key] = stateV2[key];
    }
  }
  return state;
}
function toV2State(state) {
  const stateV2 = {
    values: {},
    data: {},
    text: state.text || ""
  };
  for (const key in state) {
    if (key !== "text") {
      stateV2[key] = state[key];
    }
  }
  return stateV2;
}

export {
  fromV2State,
  toV2State
};
